export default __webpack_public_path__ + "static/media/kbstock.dc332bad.png";